"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("@chakra-ui/react");
const react_2 = __importDefault(require("react"));
const useLangContext_1 = require("../../hooks/useLangContext");
const formatSIRENFromSIRET_1 = __importDefault(require("../../utils/formatSIRENFromSIRET"));
const Text_1 = __importDefault(require("../_core/Text"));
const locales_1 = __importDefault(require("./locales"));
const Client = ({ client }) => {
    var _a;
    const { syncLocales } = (0, useLangContext_1.useLangContext)();
    syncLocales(locales_1.default);
    const siren = (0, formatSIRENFromSIRET_1.default)((_a = client.legalRegistrationNumber) !== null && _a !== void 0 ? _a : '');
    return (react_2.default.createElement(react_1.Stack, { spacing: "space-4" },
        react_2.default.createElement(Text_1.default, null, `**${client.name}**`),
        react_2.default.createElement(Text_1.default, null,
            client.street ? `${client.street} ` : null,
            client.zip || client.city ? `${client.zip} ${client.city}, ` : null,
            client.country),
        client.legalRegistrationNumber ? (react_2.default.createElement(Text_1.default, null, locales_1.default.formatString(locales_1.default.siren, { siren }))) : null,
        client.vatId !== '' ? (react_2.default.createElement(Text_1.default, null, locales_1.default.formatString(locales_1.default.vatId, { vatId: client.vatId }))) : null));
};
exports.default = Client;
